import Storage from '../Storage';

export default class LocalStorageDriver {
  storage: typeof Storage;

  constructor() {
    this.storage = Storage;
  }

  get(key: string) {
    return Promise.resolve(this.storage.getObject(key, this.storage.STORAGE_LOCAL));
  }

  set(key: string, value: unknown) {
    return Promise.resolve(this.storage.saveObject(key, value, this.storage.STORAGE_LOCAL));
  }

  onKeyChange(key: string, callback: (value: unknown) => void) {
    window.addEventListener('storage', (e) => {
      if (e.key !== key) {
        return;
      }

      // todo json parser to separate service

      callback(JSON.parse(e.newValue!));
    });
  }
}
